import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\Components\\Common\\Bannerswiper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\Components\\Common\\FullBanner.js");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\Components\\ContactUsForm.js");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\Components\\Homepage\\FrequentQuestions.js");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\Components\\ReadMore.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\Components\\ResponsiveSwiper.js");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\node_modules\\next\\dist\\client\\link.js");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\styles\\CommonBanner.module.scss");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\styles\\Homepage\\Getstartednow.module.scss");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\Ui_Elements\\OrangeSpan\\OrangeSpan.module.scss");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\styles\\Homepage\\WhatsOurClient.module.scss");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\styles\\ClientsTogether.module.scss");
;
import(/* webpackMode: "eager" */ "D:\\projects\\Vidyalaya_LMS_Website_NEXTJS\\styles\\Homepage\\CompanyKeyExecutive.module.scss");
